//Get
const CHATGROUP_DATA = {
  CHATGROUP_DATA_LOAD: "CHATGROUP_DATA_LOAD",
  CHATGROUP_DATA_SUCCESS: "CHATGROUP_DATA_SUCCESS",
  CHATGROUP_DATA_FAIL: "CHATGROUP_DATA_FAIL",
};
const CHATGROUP_GET_API = "/chat/all_groups";

//Get user metric
const USERMETRICS_DATA = {
  USERMETRICS_DATA_LOAD: "USERMETRICS_DATA_LOAD",
  USERMETRICS_DATA_SUCCESS: "USERMETRICS_DATA_SUCCESS",
  USERMETRICS_DATA_FAIL: "USERMETRICS_DATA_FAIL",
};
const USERMETRICS_GET_API = "/chat/userMetrics";

//Get chat metric
const CHATMETRICS_DATA = {
  CHATMETRICS_DATA_LOAD: "CHATMETRICS_DATA_LOAD",
  CHATMETRICS_DATA_SUCCESS: "CHATMETRICS_DATA_SUCCESS",
  CHATMETRICS_DATA_FAIL: "CHATMETRICS_DATA_FAIL",
};
const CHATMETRICS_GET_API = "/chat/chatMetrics";

//Get WV metric
const WVMETRICS_DATA = {
  WVMETRICS_DATA_LOAD: "WVMETRICS_DATA_LOAD",
  WVMETRICS_DATA_SUCCESS: "WVMETRICS_DATA_SUCCESS",
  WVMETRICS_DATA_FAIL: "WVMETRICS_DATA_FAIL",
};
const WVMETRICS_GET_API = "/chat/wvAppMetrics";

// Get one by id
const GROUPMESSAGE_GET_DATA = {
  GROUPMESSAGE_GET_DATA_LOAD: "GROUPMESSAGE_GET_DATA_LOAD",
  GROUPMESSAGE_GET_DATA_SUCCESS: "GROUPMESSAGE_GET_DATA_SUCCESS",
  GROUPMESSAGE_GET_DATA_FAIL: "GROUPMESSAGE_GET_DATA_FAIL",
  GROUPMESSAGE_CLEAR_DATA: "GROUPMESSAGE_CLEAR_DATA", //  to reset

};

const GROUPMESSAGE_GET_DETAIL_API = "/chat/messagesById/";


// Delete group member
const GROUPMEMBER_DELETE_DATA = {
  GROUPMEMBER_DELETE_DATA_LOAD: "GROUPMEMBER_DELETE_DATA_LOAD",
  GROUPMEMBER_DELETE_DATA_SUCCESS: "GROUPMEMBER_DELETE_DATA_SUCCESS",
  GROUPMEMBER_DELETE_DATA_FAIL: "GROUPMEMBER_DELETE_DATA_FAIL",
};

const GROUPMEMBER_DELETE_API = "/chat/deleteParticipant";

// Add Message
const GROUPMESSAGE_ADD_DATA = {
  GROUPMESSAGE_ADD_DATA_LOAD: "GROUPMESSAGE_ADD_DATA_LOAD",
  GROUPMESSAGE_ADD_DATA_SUCCESS: "GROUPMESSAGE_ADD_DATA_SUCCESS",
  GROUPMESSAGE_ADD_DATA_FAIL: "GROUPMESSAGE_ADD_DATA_FAIL",
};
const GROUPMESSAGE_POST_API = "/chat/addMessages";

// Add Message
const GROUPMEMBER_ADD_DATA = {
  GROUPMEMBER_ADD_DATA_LOAD: "GROUPMEMBER_ADD_DATA_LOAD",
  GROUPMEMBER_ADD_DATA_SUCCESS: "GROUPMEMBER_ADD_DATA_SUCCESS",
  GROUPMEMBER_ADD_DATA_FAIL: "GROUPMEMBER_ADD_DATA_FAIL",
};
const GROUPMEMBER_POST_API = "/chat/addParticipants";

//Import Chat
const CHAT_IMPORT_DATA = {
  CHAT_IMPORT_DATA_LOAD:'CHAT_IMPORT_DATA_LOAD',
  CHAT_IMPORT_DATA_SUCCESS:'CHAT_IMPORT_DATA_SUCCESS', 
  CHAT_IMPORT_DATA_FAIL:'CHAT_IMPORT_DATA_FAIL'
}

const CHAT_IMPORT_API = '/chat/chatUpload '

//Chat Group Audit data
const CHAT_GROUPAUDIT_DATA = {
  CHAT_GROUPAUDIT_DATA_LOAD:'CHAT_GROUPAUDIT_DATA_LOAD',
  CHAT_GROUPAUDIT_DATA_SUCCESS:'CHAT_GROUPAUDIT_DATA_SUCCESS', 
  CHAT_GROUPAUDIT_DATA_FAIL:'CHAT_GROUPAUDIT_DATA_FAIL'
}

const CHAT_GROUPAUDIT_API = '/chat/chatAuditByGroup'

//Chat User Audit data
const CHAT_USERAUDIT_DATA = {
  CHAT_USERAUDIT_DATA_LOAD:'CHAT_USERAUDIT_DATA_LOAD',
  CHAT_USERAUDIT_DATA_SUCCESS:'CHAT_USERAUDIT_DATA_SUCCESS', 
  CHAT_USERAUDIT_DATA_FAIL:'CHAT_USERAUDIT_DATA_FAIL'
}

const CHAT_USERAUDIT_API = '/chat/chatAuditByEmp'

export{
  CHATGROUP_DATA,
  CHATGROUP_GET_API,
  GROUPMEMBER_DELETE_DATA,
  GROUPMEMBER_DELETE_API,
  GROUPMESSAGE_GET_DATA,
  GROUPMESSAGE_GET_DETAIL_API,
  GROUPMESSAGE_ADD_DATA,
  GROUPMESSAGE_POST_API,
  CHATMETRICS_DATA,
  CHATMETRICS_GET_API,
  USERMETRICS_DATA,
  USERMETRICS_GET_API,
  GROUPMEMBER_ADD_DATA,
  GROUPMEMBER_POST_API, 
  WVMETRICS_DATA,
  WVMETRICS_GET_API,
  CHAT_IMPORT_DATA,
  CHAT_IMPORT_API, 
  CHAT_GROUPAUDIT_DATA,
  CHAT_GROUPAUDIT_API, 
  CHAT_USERAUDIT_DATA,
  CHAT_USERAUDIT_API,     
}